
import { JettySelect } from "./JettySelect";
import { DateSelect } from "./DateSelect";
import { PaxSelect, type PaxCount } from "./PaxSelect";
import type { TripType } from "@/types/port";
import type { DestinationList } from "@/types/destination";
import type { OriginList, TicketTypeList } from "@/types/init";

interface PortSearchFormProps {
  tripType: TripType;
  origin: OriginList | null;
  destination: DestinationList | null;
  departureDate: Date;
  returnDate: Date;
  pax: PaxCount;

  originList: OriginList[];
  destinationList: DestinationList[];
  ticketTypeList: TicketTypeList[];

  onOriginChange: (value: OriginList) => void;
  onDestinationChange: (value: DestinationList) => void;
  onDepartureDateChange: (value: Date) => void;
  onReturnDateChange: (value: Date) => void;
  onPaxChange: (value: PaxCount) => void;
}

export function PortSearchForm({
  tripType,
  origin,
  destination,
  departureDate,
  returnDate,
  pax,
  originList,
  destinationList,
  ticketTypeList,
  onOriginChange,
  onDestinationChange,
  onDepartureDateChange,
  onReturnDateChange,
  onPaxChange,
}: PortSearchFormProps) {

  return (
    <>
      {/* Origin */}
      <div className="flex-1">
          <JettySelect
          label="Origin"
          value={origin}
          options={originList}
          onChange={onOriginChange}
        />
      </div>

      {/* Destination */}
      <div className="flex-1">
        <JettySelect
          label="Destination"
          value={destination}
          options={destinationList}
          onChange={onDestinationChange}
        />
      </div>

      {/* Departure Date */}
      <div className="flex-1">
        <DateSelect
          label="Departure Date"
          value={departureDate}
          onChange={onDepartureDateChange}
        />
      </div>

      {/* Return Date */}
      {tripType === "return" && (
        <div className="flex-1">
          <DateSelect
            label="Return Date"
            value={returnDate}
            disabled={{ before: departureDate }}
            onChange={onReturnDateChange}
          />
        </div>
      )}

      {/* Passengers */}
      <div className="flex-1 min-w-0">
        <PaxSelect
          label="Passengers"
          value={pax}
          ticketTypeList={ticketTypeList}
          onChange={onPaxChange}
        />
      </div>
    </>
  );
}
